import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { core } from "@/lib/mh";
import { errText } from "@/lib/http";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, Field, PrimaryBtn, ErrorNote } from "@/components/mh/AuthShell";

export function AcceptInvite() {
  const { token } = useParams();
  const { acceptInvite } = useAuth();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [name, setName] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  useEffect(() => { core.inviteInfo(token).then((r) => setInfo(r.data)).catch((e) => setInfo({ error: errText(e) })); }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await acceptInvite({ token, name, password: pw });
      nav("/");
    } catch (e2) {
      setErr(errText(e2));
    }
  };
  if (!info) return <AuthShell eyebrow="Invite" title="Checking invite…" />;
  if (info.error) return <AuthShell testId="invite-invalid" eyebrow="Invite" title="This invite can't be used" footer={<Link to="/login" className="underline">Go to sign in</Link>}><p className="text-sm text-muted-foreground">{info.error}</p></AuthShell>;
  return (
    <AuthShell testId="invite-page" eyebrow={`Invite · ${info.role}`} title={<>Join <em>{info.workspace_name}</em></>}>
      <form onSubmit={submit} className="space-y-4">
        <p className="text-sm text-muted-foreground">You're joining as <span className="text-foreground">{info.email}</span>.{info.existing_user && " You already have an account, so enter your current password."}</p>
        {!info.existing_user && <Field label="Your name" value={name} onChange={(e) => setName(e.target.value)} testId="invite-name" />}
        <Field label={info.existing_user ? "Current password" : "Set a password (8+ characters)"} type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} testId="invite-password" />
        <ErrorNote>{err}</ErrorNote>
        <PrimaryBtn type="submit" testId="invite-submit">Accept and enter</PrimaryBtn>
      </form>
    </AuthShell>
  );
}

export function RequestAccess() {
  const [f, setF] = useState({ name: "", email: "", company: "", message: "" });
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const audit = new URLSearchParams(window.location.search).get("audit");
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    try {
      await core.requestWorkspace({ ...f, audit_id: audit });
      setDone(true);
    } catch (e2) {
      setErr(errText(e2));
    }
  };
  return (
    <AuthShell testId="request-access-page" eyebrow="Request a workspace" title={done ? "Request received." : <>Get your own <em>command center.</em></>} footer={<Link to="/login" className="underline underline-offset-4">Already invited? Sign in</Link>}>
      {done ? <p className="text-sm text-muted-foreground" data-testid="request-done">The Manahouse team will set up your workspace and send you an invite link.</p> : (
        <form onSubmit={submit} className="space-y-4">
          <Field label="Your name" required value={f.name} onChange={set("name")} testId="request-name" />
          <Field label="Work email" type="email" required value={f.email} onChange={set("email")} testId="request-email" />
          <Field label="Company" value={f.company} onChange={set("company")} testId="request-company" />
          <Field label="What do you want agents to do first?" value={f.message} onChange={set("message")} testId="request-message" />
          <ErrorNote>{err}</ErrorNote>
          <PrimaryBtn type="submit" testId="request-submit">Request workspace</PrimaryBtn>
        </form>
      )}
    </AuthShell>
  );
}
